import script from "./PrimaryButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PrimaryButton.vue?vue&type=script&setup=true&lang=js"

import "./PrimaryButton.vue?vue&type=style&index=0&id=946f5370&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-946f5370"]])

export default __exports__